import React from 'react'
import {Col, Row} from "reactstrap";

const CardTitleComponent = ({
    icon,
    title,
    onClose = null,
    onAdd = null,
}) => <Row>
    <Col> <i className={icon}/>&nbsp;{title} </Col>
    <Col>
        <div className="d-flex">
            <div className="ml-auto d-flex">
                {
                    onAdd && <div className={'icon-button'}  onClick={onAdd}>
                        <i className="fa fa-plus"/>
                    </div>
                }
                {
                    onClose && <div className={'icon-button'} onClick={onClose}>
                        <i className={'fa fa-times'} />
                    </div>
                }
            </div>
        </div>
    </Col>
</Row>

export default CardTitleComponent